import ImportChannelAction from "./actions-item/modal-action/import-channel/ImportChannelAction";
import ImportChannelModalContent from "./actions-item/modal-action/import-channel/modal-content/ImportChannelModalContent";

export const componentsMap = {
    ImportChannelAction,
    ImportChannelModalContent
}
